import { useEffect, useState } from 'react';
import { Check, UserPlus } from 'lucide-react';
import { steamBotError, steamBotService } from '../services/steamBotService';
import type { SteamBotStatus } from '../services/steamBotService';

export function WelcomeSteamStep() {
    const [status, setStatus] = useState<SteamBotStatus | null>(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => {
        let active = true;
        const load = async () => {
            try { const data = await steamBotService.status(); if (active) setStatus(data); }
            catch (e) { if (active) setError(steamBotError(e)); }
        };
        void load();
        const timer = setInterval(() => { if (document.visibilityState === 'visible') void load(); }, 5000);
        return () => { active = false; clearInterval(timer); };
    }, []);
    const state = status?.subscription?.friendState;
    const connected = status?.subscription?.enabled && state === 'connected';
    const failed = state?.startsWith('request_failed');
    const requested = status?.subscription?.enabled && !failed;
    const connect = async () => {
        setBusy(true); setError('');
        try { setStatus(await steamBotService.connect()); }
        catch (e) { setError(steamBotError(e)); }
        finally { setBusy(false); }
    };
    return <section className="wizard-slide wizard-steam">
        <div className="wizard-steam-logo"><img src="/icons/socials/Icon_Steam.png" alt="Steam" /></div>
        <h2 className="wizard-team-title">Your reminders. Right in Steam.</h2>
        <p className="wizard-team-subtitle">Connect the StratSync chatbot to the Steam account linked to your FACEIT login.</p>
        <div className="wizard-steam-benefits">
            <p><Check size={18} /> Know when you win a raffle or giveaway.</p>
            <p><Check size={18} /> Start the week with fresh leaderboards and your Raffle Points summary.</p>
            <p><Check size={18} /> Get reminders before your team matches and practice sessions.</p>
        </div>
        <div className="wizard-steam-action">
            {connected ? <p role="status" className="wizard-steam-success"><Check size={20} /> Connected on Steam</p>
                : requested ? <p role="status">{state === 'pending' ? 'Invitation sent — accept it in Steam.' : state === 'request_uncertain' ? 'Steam has not confirmed the invitation yet. Check your Steam friends list.' : 'Your friend invitation is being prepared. You can continue while the bot adds you.'}</p>
                : <button type="button" className="wizard-btn wizard-btn-primary" disabled={busy || !status?.available} onClick={() => void connect()}><UserPlus size={18} />{busy ? 'Requesting invitation…' : failed ? 'Retry friend invitation' : 'Connect with Steam bot'}</button>}
            {status?.botProfile && <a href={status.botProfile} target="_blank" rel="noreferrer">View StratSync bot profile ↗</a>}
            {error && <p role="alert">{error}</p>}
            {status && !status.available && <p>Steam reminders are currently unavailable. You can connect later from the main menu.</p>}
        </div>
        <p className="wizard-steam-note">Connecting includes important StratSync announcements. Optional — continue without connecting if you prefer. You can change your optional reminders and select your teams in Steam reminder settings on the main menu.</p>
    </section>;
}
